import { Button } from "components/Button/Button"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { VRScene } from "./vr-scene"
import { useLangContext } from "context/Lang"


export const Hero=()=>{
     const { gW } = useLangContext();

    return (
        <section className="relative min-h-screen overflow-hidden pt-20">
            <div className="absolute inset-0 z-0 opacity-40">
                <VRScene />
            </div>

            <div className="container relative z-0 mx-auto px-6 py-20 md:py-32">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="mx-auto max-w-4xl text-center"
                >
                    {/* Badge */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                        className="
                            mb-6 inline-block 
                            rounded-full border 
                            border-primary-700 
                            bg-primary-600/20 
                            px-4 py-1.5 
                            text-sm font-medium 
                            text-primary-900
                        "
                    >
                        {gW("future-learning")}
                    </motion.div>

                    {/* Title */}
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                        className="
                            mb-6 
                            text-balance 
                            text-5xl md:text-7xl 
                            font-extrabold 
                            leading-tight tracking-tight 
                            text-primary-900
                        "
                    >
                        {gW("experience-education")}{" "}
                        <span className="bg-gradient-to-r from-primary-700 to-primary-900 bg-clip-text text-transparent">
                            {gW("virtual-reality")}
                        </span>
                    </motion.h1>

                    {/* Description */}
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.5 }}
                        className="
                            mx-auto mb-10 
                            max-w-2xl 
                            text-lg md:text-xl 
                            leading-relaxed 
                            text-primary-800
                        "
                    >
                        {gW("hero-description")}
                    </motion.p>

                    {/* Buttons */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.6 }}
                        className="flex flex-col items-center justify-center gap-4 sm:flex-row"
                    >
                        <Link to="#">
                            <Button
                                size="lg"
                                className="
                                    group relative overflow-hidden 
                                    bg-primary-700 
                                    text-white 
                                    hover:bg-primary-800 
                                    active:bg-primary-900
                                "
                            >
                                <span className="relative z-10">{gW("start-learning")}</span>
                                <motion.div
                                    className="absolute inset-0 bg-primary-900"
                                    initial={{ x: "-100%" }}
                                    whileHover={{ x: 0 }}
                                    transition={{ duration: 0.3 }}
                                />
                            </Button>
                        </Link>

                        <Button
                            size="lg"
                            variant="outline"
                            className="
                                border-primary-700 
                                text-primary-900 
                                hover:bg-primary-700/10
                            "
                        >
                            {gW("watch-demo")}
                        </Button>
                    </motion.div>
                </motion.div>
            </div>

            {/* Scroll indicator */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.8 }}
                className="absolute bottom-10 left-1/2  -translate-x-1/2"
            >
                <motion.div
                    animate={{ y: [0, 10, 0] }}
                    transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY, ease: "easeInOut" }}
                    className="flex flex-col items-center gap-2 text-sm text-primary-800"
                >
                    <span>{gW("scroll-to-explore")}</span>
                    <svg
                        className="h-5 w-5 text-primary-900"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                    </svg>
                </motion.div>
            </motion.div>
        </section>
    )
}
